import makeStyles from "@mui/styles/makeStyles";
import { DialogContentProps } from "./DialogContent.types";

export const useDialogContentStyles = makeStyles((theme) => ({
  root: (props: DialogContentProps) => ({
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop:
      props.paddingTop !== undefined
        ? `${props.paddingTop * parseInt(theme.spacing(1), 10)}px !important`
        : "20px !important",
    paddingBottom:
      props.paddingBottom !== undefined
        ? `${props.paddingBottom * parseInt(theme.spacing(1), 10)}px !important`
        : "20px !important",
    [theme.breakpoints.up("md")]: {
      paddingLeft: 24,
      paddingRight: 24,
    },
  }),
}));
